//  @flow

import * as React from 'react';

import './style.css';

type OverlayProps = {
  children: React.Node,
  className?: string
};

const Overlay = (props: OverlayProps) => {
  const { className = '' } = props;
  return <div className={`${className} overlay-content`}>{props.children}</div>;
};
Overlay.defaultProps = {
  className: ''
};

export default Overlay;



// WEBPACK FOOTER //
// ./src/Components/Overlay/index.js